/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.


import { HotKeys } from 'react-hotkeys'
import IconSVG from 'svg-inline-react'

import DropDown from 'components/DropDown'
import Input from 'shared-web/src/components/Input'
import MakeInputChangeHandler from 'mixins/MakeInputChangeHandler'
import TagColorSelectorDropdown from 'components/settings/tags/TagColorSelectorDropdown'
import classnames from 'classnames'
import { captureExceptions } from 'utils/SentryHelpers'
import { getNormalizedTagColor } from 'utils/TagAppearanceHelper'

import 'styles/components/settings/tags/TagEditingInput.styl'

const TagEditingInput = React.createClass({
  mixins: [require('react-onclickoutside'), MakeInputChangeHandler],

  getInitialState() { return {
    showColorDropdown: false,
    selectedColor: this.props.selectedColor,
    creatingTag: false
  } },

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedColor != null) { this.setState({ selectedColor: nextProps.selectedColor }) }

    if (this.state.creatingTag) {
      const newTagId = _.findKey(nextProps.tagsById, { name: this.tagName() })

      if (newTagId) {
        this.setState({ creatingTag: false })
        this.props.onCreate(parseInt(newTagId))
        return this.props.onClose()
      }
    }
  },

  getAllTags() {
    return this.props.customerTagList.concat(this.props.conversationTagList)
  },

  isTagNameValid(tagName) {
    let editTag
    if (tagName == null) { ({ tagName } = this.state) }
    const allTags = this.getAllTags()
    if (this.props.editingTag) {
      editTag = _.find(allTags, { 'id': this.props.editingTag.id })
    }

    const tagAlreadyExists = _.some(allTags, tag => tag.name === tagName)
    return !tagAlreadyExists || ((editTag != null ? editTag.name : undefined) === tagName)
  },

  colorClicked(tagColor) {
    return this.setState({
      showColorDropdown: false,
      selectedColor: tagColor
    })
  },

  renderColorDropdown() {
    return (
      <TagColorSelectorDropdown
        colorClicked={this.colorClicked}
        onClickOutside={() => this.setState({ showColorDropdown: false })} />
    )
  },

  onSaveOrUpdateTag() {
    const saved = this.createOrUpdateTag()
    if (saved && !this.props.onCreate) { return this.props.onClose() }
  },

  tagName(trim) {
    if (trim == null) { trim = true }
    const tagName = trim ? (this.state.tagName != null ? this.state.tagName.trim() : undefined) : this.state.tagName
    return tagName || (this.props.editingTag != null ? this.props.editingTag.name : undefined)
  },

  validInput() {
    const colorNotSelected = (this.state.selectedColor == null)
    const emptyTagName = (this.tagName() == null)
    const invalidTagName = !this.isTagNameValid()
    if (emptyTagName || colorNotSelected || invalidTagName) {
      if (typeof this.props.invalidSaveAttempt === 'function') {
        this.props.invalidSaveAttempt(emptyTagName, colorNotSelected, invalidTagName)
      }
      return false
    }

    return true
  },

  // return: boolean, if tag has been saved
  createOrUpdateTag() {
    if (!this.validInput()) { return false }

    const body = {
      name: this.tagName(),
      color: this.state.selectedColor,
      targetType: this.props.tagType
    }
    if (this.props.editingTag) {
      this.app.actions.TagActions.updateTag(this.props.editingTag.id, body)
    } else {
      this.app.actions.TagActions.createTag(body)
      if (this.props.onCreate != null) { this.setState({ creatingTag: true }) }
    }
    return true
  },

  handleClickOutside(event) {
    if (!this.props.disableClickOutsideSave) {
      this.createOrUpdateTag()
      return this.props.onClose()
    }
  },

  handleInputKeyDown(event) {
    // disable newline when using <Textarea>
    if (this.props.multiLine && (event.keyCode === 13)) { return event.preventDefault() }
  },

  handleInputChange(newTagName) {
    return (typeof this.props.onTagNameChange === 'function' ? this.props.onTagNameChange(newTagName) : undefined)
  },

  onTagColorClick() {
    if (!this.props.disableColorDropdown) { return this.setState({ showColorDropdown: true }) }
  },

  tagColorBackgroundColor() {
    if (this.state.selectedColor != null) {
      return `#${getNormalizedTagColor(this.state.selectedColor)}`
    } else {
      return 'transparent'
    }
  },

  render() {
    return (
      <div
        className={classnames('create-tag', {
          'tag-multiline': this.props.multiLine
        })}
        onFocus={function(e) { return e.stopPropagation() }}>
        <div
          onClick={this.onTagColorClick}
          className={classnames('tag-color', {
            'tag-color-empty': (this.state.selectedColor == null)
          })}
          style={{
            backgroundColor: this.tagColorBackgroundColor(),
            color: 'var(--main-navy-extra-dark)',
          }} />
        {this.state.showColorDropdown ? this.renderColorDropdown() : undefined}
        <HotKeys
          className="input-container"
          keyMap={{
            'saveOrUpdateTag': ['enter'],
            'close': 'esc'
          }}
          handlers={{
            'saveOrUpdateTag': this.onSaveOrUpdateTag,
            'close': this.props.onClose
          }}>
          <Input
            type="text"
            placeholder="Tag name"
            autoFocus={true}
            valueLink={{
              value: this.tagName(false),
              requestChange: this.makeInputChangeHandler('tagName', this.handleInputChange)
            }}
            isValid={this.isTagNameValid()}
            errorLabel="Sorry, this name is taken"
            isTextAreaAutosize={this.props.multiLine}
            onKeyDown={this.handleInputKeyDown} />
        </HotKeys>
        <IconSVG
          className="cancel-tag-button"
          src={require('!svg-inline?removeTags=true!images/icons/times-icon.svg')}
          onClick={this.props.onClose} />
      </div>
    )
  }
})

export default Marty.createContainer(TagEditingInput, {
  listenTo: ['stores.TagStore'],

  fetch: {
    customerTagList() {
      return this.app.stores.TagStore.getOrFetchCustomerTagList()
    },

    conversationTagList() {
      return this.app.stores.TagStore.getOrFetchConversationTagList()
    },

    tagsById() {
      return this.app.stores.TagStore.getOrFetchTagList()
    }
  },

  failed(errors) {
    captureExceptions(errors)
    return <div />
  }
})



// WEBPACK FOOTER //
// ./src/scripts/components/settings/tags/TagEditingInput.js